// VFX: Story Poll Bars
// Slug: ig_story-poll_vote-bar_loop
// Category: ui-elements
import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate, spring } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;
type Props = { question?: string; optionA?: string; optionB?: string; finalA?: number };

export default function IgStoryPollVoteBarLoop({
  question = "Qual prefere?",
  optionA = "Opção A",
  optionB = "Opção B",
  finalA = 67,
}: Props) {
  const frame = useCurrentFrame();
  const { fps, durationInFrames } = useVideoConfig();
  const sp = spring({ frame, fps, config: { stiffness: 80, damping: 18 } });
  const aPct = interpolate(sp, [0, 1], [50, finalA], clamp);
  const bPct = 100 - aPct;
  const pulse = 1 + 0.02 * Math.sin((frame / durationInFrames) * Math.PI * 4);
  const aWinning = aPct >= 50;
  return (
    <AbsoluteFill
      style={{
        background: "linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)",
        justifyContent: "center",
        alignItems: "center",
        padding: "0 60px",
        flexDirection: "column",
        gap: 32,
      }}
    >
      <div
        style={{
          fontFamily: "system-ui, sans-serif",
          fontSize: 44,
          fontWeight: 700,
          color: "#fff",
          textAlign: "center",
        }}
      >
        {question}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 18, width: "100%", maxWidth: 880 }}>
        <PollBar label={optionA} pct={aPct} accent="#f472b6" highlight={aWinning} pulse={pulse} />
        <PollBar label={optionB} pct={bPct} accent="#22d3ee" highlight={!aWinning} pulse={pulse} />
      </div>
    </AbsoluteFill>
  );
}

function PollBar({
  label,
  pct,
  accent,
  highlight,
  pulse,
}: {
  label: string;
  pct: number;
  accent: string;
  highlight: boolean;
  pulse: number;
}) {
  return (
    <div
      style={{
        position: "relative",
        height: 88,
        background: "rgba(255,255,255,0.12)",
        borderRadius: 18,
        overflow: "hidden",
        border: "1px solid rgba(255,255,255,0.18)",
        transform: highlight ? `scale(${pulse})` : "scale(1)",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          width: `${pct}%`,
          background: `linear-gradient(90deg, ${accent}, ${accent}cc)`,
          boxShadow: highlight ? `0 0 30px ${accent}aa` : "none",
        }}
      />
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 28px",
          fontFamily: "system-ui, sans-serif",
          fontWeight: 700,
          color: "#fff",
          fontSize: 30,
        }}
      >
        <span>{label}</span>
        <span>{Math.round(pct)}%</span>
      </div>
    </div>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
